import Component from '@glimmer/component';

import { hash } from '@ember/helper';

import WizardStep from 'rise-ui/components/wizard-step.gjs';
import WizardStepDescription from 'rise-ui/components/wizard-step-description.gjs';
import WizardStepNote from 'rise-ui/components/wizard-step-note.gjs';

export default class WizardStepsComponent extends Component {
  <template>
    <ol class="c-wizard-steps"
      ...attributes
    >
      {{#let
        (component WizardStep selected=@selected last=@last)
        (component WizardStepDescription)
        (component WizardStepNote)
        as | step description note |
      }}
      {{yield (hash Step=step StepDescription=description StepNote=note)}}
      {{/let}}
    </ol>
  </template>
}
